import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'
import { sendLanguageDetectedEvent } from '@/services/analytics/gtm'

export const languages: Record<string, { nativeName: string }> = {
  'en-US': { nativeName: 'English' },
  es: { nativeName: 'Español' },
}

i18next
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  .use(HttpApi)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    fallbackLng: 'en-US',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      loadPath: '/locales/{{lng}}.json', //root path is /public folder
    },
  })

i18next.on('initialized', () => {
  sendLanguageDetectedEvent(i18next.language)
})

export default i18next
